import type { WebsiteSettings } from './types';

export function applyWebsiteMeta(websiteData: WebsiteSettings) {
    // Apply dynamic meta tags
    if (websiteData.siteName) {
        const metaTitle = document.querySelector('meta[name="title"]');
        const ogTitle = document.querySelector('meta[property="og:title"]');
        const twitterTitle = document.querySelector('meta[property="twitter:title"]');
        if (metaTitle) metaTitle.setAttribute('content', websiteData.siteName);
        if (ogTitle) ogTitle.setAttribute('content', websiteData.siteName);
        if (twitterTitle) twitterTitle.setAttribute('content', websiteData.siteName);
    }

    if (websiteData.siteDescription) {
        const metaDesc = document.querySelector('meta[name="description"]');
        const ogDesc = document.querySelector('meta[property="og:description"]');
        const twitterDesc = document.querySelector('meta[property="twitter:description"]');
        if (metaDesc) metaDesc.setAttribute('content', websiteData.siteDescription);
        if (ogDesc) ogDesc.setAttribute('content', websiteData.siteDescription);
        if (twitterDesc) twitterDesc.setAttribute('content', websiteData.siteDescription);
    }

    // Apply dynamic favicon
    if (websiteData.favicon) {
        let faviconLink = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
        if (faviconLink) {
            const isBase64 = websiteData.favicon.startsWith('data:');
            const faviconUrl = isBase64 ? websiteData.favicon : `${websiteData.favicon}?t=${Date.now()}`;
            faviconLink.href = faviconUrl;
            faviconLink.type = isBase64 ? websiteData.favicon.split(';')[0].split(':')[1] : 'image/png';
            if (!isBase64) {
                faviconLink.onerror = () => { faviconLink!.href = '/vite.svg'; };
            }
        }
    }
}
